<div class="bot-container__title" *ngIf="showHelperText">
  <div class="risk-helper-text --bot">
    {{riskBotHelperText}}
  </div>
</div>

<div class="subSectionHeader">
  <div class="attribute-text">
    <form-factory [formGroup]="formGroup" [model]="firstPassCodingBotEnabled" (onChange)="onChangeRiskBot($event)"></form-factory>
    <form-factory *ngIf="isFirstPassCodingBotEnabled && showAutoPendEmptyNlpResult" [formGroup]="formGroup" [model]="autoPendEmptyNlpResult"></form-factory>
    <ng-container *ngIf="isCodingReviewModeDxV3">
      <form-factory [formGroup]="formGroup" [model]="noNetNewOpportunityAutoPend"></form-factory>
      <form-factory [formGroup]="formGroup" [model]="adminSuppressEve"></form-factory>
    </ng-container>
  </div>
</div>

<app-modal [(visible)]="isRiskBotPopupVisible" header="ATTENTION" (onCancel)="onRiskBotPopupButtonClick('cancel')">
  <div class="risk-bot-settings">
    <p class="risk-bot-settings__label">You are <span class="risk-bot-settings__bot-options">{{selectedRiskBotOption}}</span> EVE First Pass Coding for project</p>
    <p class="risk-bot-settings__label">{{projectName}}</p>
    <p class="risk-bot-settings__bot-text">{{riskBotPopUpText}}</p>
  </div>
  <footer>
    <app-button classes="secondary" text="CONTINUE" (onClick)="onRiskBotPopupButtonClick('continue')"></app-button>
  </footer>
</app-modal>
